// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/mcp.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { PageRequest, PageResponse } from "./common_pb.js";

/**
 * @generated from message omnios.v1.McpServer
 */
export const McpServer = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.McpServer",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "transport_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "command", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "args", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "oauth_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "has_credentials", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "created_at", kind: "message", T: Timestamp },
    { no: 12, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.CreateMcpServerRequest
 */
export const CreateMcpServerRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateMcpServerRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "transport_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "command", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "args", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "oauth_client_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "oauth_client_secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "oauth_auth_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "oauth_token_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "oauth_scopes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 15, name: "oauth_redirect_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "env", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ],
);

/**
 * @generated from message omnios.v1.UpdateMcpServerRequest
 */
export const UpdateMcpServerRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateMcpServerRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 10, name: "env", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ],
);

/**
 * @generated from message omnios.v1.DeleteMcpServerRequest
 */
export const DeleteMcpServerRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteMcpServerRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.DeleteMcpServerResponse
 */
export const DeleteMcpServerResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteMcpServerResponse",
  [],
);

/**
 * @generated from message omnios.v1.ListMcpServersRequest
 */
export const ListMcpServersRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListMcpServersRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListMcpServersResponse
 */
export const ListMcpServersResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListMcpServersResponse",
  () => [
    { no: 1, name: "servers", kind: "message", T: McpServer, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.InitiateMcpOAuthRequest
 */
export const InitiateMcpOAuthRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.InitiateMcpOAuthRequest",
  () => [
    { no: 1, name: "server_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.InitiateMcpOAuthResponse
 */
export const InitiateMcpOAuthResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.InitiateMcpOAuthResponse",
  () => [
    { no: 1, name: "authorization_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CompleteMcpOAuthRequest
 */
export const CompleteMcpOAuthRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CompleteMcpOAuthRequest",
  () => [
    { no: 1, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CompleteMcpOAuthResponse
 */
export const CompleteMcpOAuthResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CompleteMcpOAuthResponse",
  () => [
    { no: 1, name: "server_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.DisconnectMcpOAuthRequest
 */
export const DisconnectMcpOAuthRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DisconnectMcpOAuthRequest",
  () => [
    { no: 1, name: "server_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.DisconnectMcpOAuthResponse
 */
export const DisconnectMcpOAuthResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DisconnectMcpOAuthResponse",
  [],
);

